import axios from "axios";

import { clearSessionToken } from "./authSessionStorage";


const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;


export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});


api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== "/login") {
      clearSessionToken();
      delete api.defaults.headers.common.Authorization;
      window.location.assign("/login");
    }
    return Promise.reject(error);
  },
);


export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    return;
  }

  delete api.defaults.headers.common.Authorization;
};


export const getApiError = (error) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail) {
    return detail;
  }
  if (Array.isArray(detail)) {
    return detail
      .map((item) => (typeof item?.msg === "string" ? item.msg : JSON.stringify(item)))
      .join(" ");
  }
  return error?.message || "Er ging iets mis.";
};